import styled from '@emotion/styled';
import { sdsPrimitiveColor } from '@staging-design-system/tokens';
import { rem } from '@utils';

const Root = styled.article`
  background: ${({ theme }) => theme.palette.common.white};
  border: ${rem(1)} solid ${({ theme }) => theme.palette.grey['200']};
  border-radius: ${rem(8)};
  padding: ${rem(24)};
  width: 100%;
`;

const Title = styled.h3`
  color: ${({ theme }) => theme.palette.common.black};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${rem(20)};
  font-weight: 600;
  line-height: ${rem(32)};
  margin: 0;
`;

const Intro = styled.p`
  color: ${({ theme }) => theme.palette.common.black};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${rem(16)};
  font-weight: 400;
  line-height: ${rem(24)};
  margin: 0 0 ${rem(24)} 0;
`;

const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
  list-style: none;
  margin: 0;
  padding: 0;
`;

const Item = styled.li`
  align-items: center;
  display: flex;
  gap: ${rem(12)};
`;

const IconWrapper = styled.span`
  align-items: center;
  background: ${sdsPrimitiveColor.pink['600']};
  border-radius: 50%;
  color: ${({ theme }) => theme.palette.common.white};
  display: flex;
  flex-shrink: 0;
  height: ${rem(22)};
  justify-content: center;
  margin-top: ${rem(2)};
  width: ${rem(22)};

  svg {
    height: ${rem(14)};
    width: ${rem(14)};
  }
`;

const ItemText = styled.p`
  color: ${({ theme }) => theme.palette.common.black};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(20)};
  margin: 0;
`;

export default {
  Root,
  Title,
  Intro,
  List,
  Item,
  IconWrapper,
  ItemText
};
